import { Link } from 'react-router-dom';
import { ModalComponent } from '../ModalComponent/ModalComponent';
import './ModalSuccessfulProductList.scss'
import { TextPage } from '../../TextPage/TextPage';

const ModalSuccessfulProductList = ({ setIsModal }) => {

    return (
        <ModalComponent
            title='Принято в работу'
            onClose={e => setIsModal(false)}
            style={{
                maxWidth: '500px',
                height: 'auto'
            }}
            child={
                <div className='modal-successful-product-list'>
                    <TextPage
                        medium
                        text={<>
                            Статус выполнения появится в <Link style={{color: '#1890FF', textDecoration: 'underline'}} className='link_blue' to='/service'>уведомлениях</Link>
                        </>}
                    />
                </div>
            }
        />
    )
}

export { ModalSuccessfulProductList }